import type { FreeSlot } from '@hedepy/common/schemas/modules/schedule/freeSlot'
import { forwardRef } from 'react'

import Icon from '@/legacy-src/components/icons/Icon'

import { ClientBookingSlotButton } from '@/src/domains/client-booking/components/ClientBookingSlotButton'

export interface ClientBookingAvailableSlotTimeSlotProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'slot'> {
  slot: FreeSlot
  selected?: boolean
}

export const ClientBookingAvailableSlotTimeSlot = forwardRef<
  HTMLButtonElement,
  ClientBookingAvailableSlotTimeSlotProps
>(({ slot, selected = false, ...props }, ref) => (
  <ClientBookingSlotButton
    ref={ref}
    variant={selected ? 'free-selected' : 'free'}
    startDate={slot.startDate}
    slotType={slot.type}
    icon={<Icon size={16} icon={selected ? 'cross' : 'plus-simple'} color="primary" />}
    {...props}
  />
))

ClientBookingAvailableSlotTimeSlot.displayName = 'ClientBookingAvailableSlotTimeSlot'
